module.exports = function(users) {
	'use strict'
	users.directive('profileDir',profileDir);
	profileDir.$inject=[];
	function profileDir() {
		return {
			template: require('./partial/profile.html'),
			controller:"userProfileController",
			controllerAs:"vmup",
			link: function(scope, element, attrs, ctrl) {
				    
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/usersModule/profile/js/directive/profileDirective.js
// module id = 637
// module chunks = 0